import script from "./clInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./clInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./clInfoAdd.vue?vue&type=style&index=0&id=7b1fab1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b1fab1a"]])

export default __exports__